import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"
import { toast } from "react-toastify"
import Cookies from "js-cookie"

export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async ({ email, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("auth/abide/login", {
        email,
        password,
      })
      if (response) {
        toast.success("Login successful, redirecting to dashboard...", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error?.message || error?.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error.response.data.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue(message)
    }
  }
)
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async ({ email }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/auth/v1/initiate-reset/${email}`,
        {}
      )
      if (response) {
        toast.success(
          "Way to go! You have successfully completed this action.!!",
          {
            icon: "🎉",
          }
        )
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const validateReset = createAsyncThunk(
  "auth/validateReset",
  async ({ token }, thunkAPI) => {
    try {
      const response = await api.get(`abide/auth/v1/validate-reset/${token}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }

      thunkAPI.dispatch(setMessage(message))
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      return thunkAPI.rejectWithValue()
    }
  }
)
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ reference, otp, password }, thunkAPI) => {
    try {
      const response = await api.post("abide/auth/v1/reset-password", {
        reference,
        otp,
        password,
      })
      if (response) {
        toast.success(
          "Password changed successfully, redirecting to login....",
          {
            icon: "🎉",
          }
        )
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post(`auth/abide/logout`, {})
      if (response) {
        Cookies.remove("_k")
        Cookies.remove("_XFRSH")
        Cookies.remove("XFRSH")
        Cookies.remove("BAMBOO")
        Cookies.remove("LILBAMBOO")
        sessionStorage.removeItem("addeditem")
        return response.data
      }
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const switchBusiness = createAsyncThunk(
  "auth/switchBusiness",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`auth/abide/switch/${id}`, {})
      if (response) {
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const refreshtoken = createAsyncThunk(
  "auth/refreshtoken",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post(`auth/abide/refresh`, {})
      if (response) {
        return response?.data
      }
    } catch (error) {
      return rejectWithValue()
    }
  }
)
//PUBLIC DASHBOARDS
export const getPublicDashboards = createAsyncThunk(
  "auth/getPublicDashboards",
  async ({ state }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/auth/v1/dashboards?state=${state}`)

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      return rejectWithValue(newMessage)
    }
  }
)
//DONATIONS
export const getPublicDonations = createAsyncThunk(
  "auth/getPublicDonations",
  async (
    { disaster, cursor, navigation, pagesize },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        `abide/auth/v1/disaster?disaster=${disaster}&cursor=${cursor}&navigation=${navigation}&page-szie=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)
//DISASTERS
export const getPublicDisaster = createAsyncThunk(
  "auth/getPublicDisaster",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/auth/v1/disaster`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)
export const getPublicDashboardDropdown = createAsyncThunk(
  "auth/getPublicDashboardDropdown ",
  async ({ dashboard }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/auth/v1/disaster/basic?dashboard=${dashboard}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      dispatch(setMessage(newMessage))
      return rejectWithValue(newMessage)
    }
  }
)
const initialState = {
  user: null,
  loading: false,
  isLoggedIn: false,
  token: null,
  disasters: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userLogin.pending, (state, { payload }) => {
      state.isLoggedIn = false
      state.user = null
      state.loading = true
    })
    builder.addCase(userLogin.fulfilled, (state, { payload }) => {
      state.loading = false
      state.isLoggedIn = true
      state.user = payload.data
    })
    builder.addCase(userLogin.rejected, (state, { payload }) => {
      state.loading = false
      state.isLoggedIn = false
      state.user = payload
    })
    builder.addCase(validateReset.fulfilled, (state, { payload }) => {
      state.user = payload
    })
    builder.addCase(resetPassword.fulfilled, (state) => {
      state.isLoggedIn = false
      state.user = null
    })
    builder.addCase(refreshtoken.fulfilled, (state, { payload }) => {
      state.isLoggedIn = true
      state.token = payload
    })
    builder.addCase(switchBusiness.fulfilled, (state, { payload }) => {
      state.isLoggedIn = true
      state.user = payload.data
    })
    builder.addCase(logout.fulfilled, (state) => {
      state.isLoggedIn = false
      state.user = null
    })
    builder.addCase(logout.rejected, (state) => {
      state.isLoggedIn = false
      state.user = null
    })
    // PUBLIC DASHBOARDS
    builder.addCase(getPublicDashboards.pending, (state) => {
      state.loading = true
      state.dashbaords = null
    })
    builder.addCase(getPublicDashboards.fulfilled, (state, { payload }) => {
      state.loading = false
      state.dashbaords = payload.data
    })
    builder.addCase(getPublicDashboards.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    // PUBLIC DONATIONS
    builder.addCase(getPublicDonations.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(getPublicDonations.fulfilled, (state, { payload }) => {
      state.loading = false
      state.data = payload.data
    })
    builder.addCase(getPublicDonations.rejected, (state) => {
      state.loading = false
      state.data = null
    })

    // PUBLIC DISASTER
    builder.addCase(getPublicDisaster.pending, (state) => {
      state.loading = true
      state.disasters = null
    })
    builder.addCase(getPublicDisaster.fulfilled, (state, { payload }) => {
      state.loading = false
      state.disasters = payload.data
    })
    builder.addCase(getPublicDisaster.rejected, (state) => {
      state.loading = false
      state.disasters = null
    })
    builder.addCase(
      getPublicDashboardDropdown.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.disasters = payload.data
      }
    )
  },
})

export default authSlice.reducer
